import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { GA_MEASUREMENT_ID } from "../analytics";

/**
 * Sends page_path to GA4 on React Router navigations (SPA).
 * Initial page view is handled by the snippet in public/index.html.
 */
export default function GoogleAnalytics() {
  const location = useLocation();
  const isFirstNavigation = useRef(true);

  useEffect(() => {
    if (typeof window.gtag !== "function") return;

    const path = location.pathname + location.search;

    if (isFirstNavigation.current) {
      isFirstNavigation.current = false;
      return;
    }

    window.gtag("config", GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }, [location]);

  return null;
}
